export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
  },
  PRODUCTS: {
    BASE: "/admin/products",
    SEARCH: "/admin/products/search",
    BY_ID: (id: number) => `/admin/products/${id}`,
  },
  PRODUCTS_USER: {
    SEARCH: "/products/search",
    BY_ID: (id: number) => `/products/${id}`,
  },
  STOCKS_ADMIN: {
    BASE: "/admin/stocks",
    SEARCH: "/admin/stocks/search",
    BY_ID: (id: number) => `/admin/stocks/${id}`,
  },
  STOCKS_USER: {
    SEARCH: "/stocks/search",
    AVAILABILITY: "/stocks/availability",
    BY_ID: (id: number) => `/stocks/${id}`,
  },
  CLIENTS: {
    BASE: "/clients",
    PAGINATED: "/clients/paginated",
    SEARCH: "/clients/search",
    BY_ID: (id: number) => `/clients/${id}`,
  },
  CLIENTS_ADMIN: {
    BASE: "/admin/clients",
    SEARCH: "/admin/clients/search",
  },
  SELLERS: {
    BASE: "/admin/sellers",
    PAGINATED: "/admin/sellers/paginated",
    SEARCH: "/admin/sellers/search",
    BY_ID: (id: number) => `/admin/sellers/${id}`,
  },
  SELLERS_USER: {
    SEARCH: "/sellers/search",
  },
  SELLER_COMMISSIONS: {
    BASE: "/admin/seller-commissions",
    SEARCH: "/admin/seller-commissions/search",
    SUMMARY: "/admin/seller-commissions/summary",
    BY_ID: (id: number) => `/admin/seller-commissions/${id}`,
    BY_SELLER: (sellerId: number) =>
      `/admin/seller-commissions/by-seller/${sellerId}`,
    BY_PERIOD: "/admin/seller-commissions/by-period",
    BY_MONTH: "/admin/seller-commissions/by-month",
  },
  RENTALS: {
    BASE: "/rentals",
    SEARCH: "/rentals/search",
    PAGINATED: "/rentals/paginated",
    SUMMARY: "/rentals/summary",
    BY_ID: (id: number) => `/rentals/${id}`,
    RETURN: (id: number) => `/rentals/${id}/return`,
    CANCEL: (id: number) => `/rentals/${id}/cancel`,
    PICKUP: (id: number) => `/rentals/${id}/pickup`,
  },
  RENTALS_ADMIN: {
    SEARCH: "/admin/rentals/search",
    BASE: "/admin/rentals",
    BY_ID: (id: number) => `/admin/rentals/${id}`,
    PICKUP: (id: number) => `/admin/rentals/${id}/pickup`,
    RETURN: (id: number) => `/admin/rentals/${id}/return`,
    CANCEL: (id: number) => `/admin/rentals/${id}/cancel`,
  },
  TAGS: {
    BASE: "/tags",
    BY_ID: (id: number) => `/tags/${id}`,
    SEARCH: "/tags/search",
    PAGINATED: "/tags/paginated",
  },
  TAGS_ADMIN: {
    BASE: "/admin/tags",
    BY_ID: (id: number) => `/admin/tags/${id}`,
    SEARCH: "/admin/tags/search",
    PAGINATED: "/admin/tags/paginated",
  },
  CONTRACTS: {
    BASE: "/contracts",
    SEARCH: "/contracts/search",
    BY_ID: (id: number) => `/contracts/${id}`,
  },
  CONTRACTS_ADMIN: {
    BASE: "/admin/contracts",
    SEARCH: "/admin/contracts/search",
    BY_ID: (id: number) => `/admin/contracts/${id}`,
  },
  COMMISSION_RATES: {
    BASE: "/admin/commission-rates",
    PAGINATED: "/admin/commission-rates/paginated",
    BY_ID: (id: number) => `/admin/commission-rates/${id}`,
  },
  INVOICES_ADMIN: {
    SEARCH: "/admin/invoices/search",
    EMIT: "/admin/invoices/emit",
    BY_ID: (id: number) => `/admin/invoices/${id}`,
    CANCEL: (id: number) => `/admin/invoices/${id}/cancel`,
    RESEND: (id: number) => `/admin/invoices/${id}/resend`,
    PDF: (id: number) => `/admin/invoices/${id}/pdf`,
    PDF_CANCELED: (id: number) => `/admin/invoices/${id}/pdf/canceled`,
    XML: (id: number) => `/admin/invoices/${id}/xml`,
    XML_CANCELED: (id: number) => `/admin/invoices/${id}/xml/canceled`,
  },
  FISCAL_EXPORT_ADMIN: {
    PERIOD_ZIP: "/admin/fiscal-documents/period/zip",
  },
  COMMERCIAL_INVOICES_ADMIN: {
    BASE: "/admin/commercial-invoices",
    BY_ID: (id: number) => `/admin/commercial-invoices/${id}`,
    REFRESH: (id: number) => `/admin/commercial-invoices/${id}/refresh`,
    PDF: (id: number) => `/admin/commercial-invoices/${id}/pdf`,
    XML: (id: number) => `/admin/commercial-invoices/${id}/xml`,
    XML_CANCELED: (id: number) =>
      `/admin/commercial-invoices/${id}/xml/canceled`,
  },
  GRADUATIONS_ADMIN: {
    BASE: "/admin/graduations",
    SEARCH: "/admin/graduations/search",
    BY_ID: (id: number) => `/admin/graduations/${id}`,
    CANCEL: (id: number) => `/admin/graduations/${id}/cancel`,
  },
  MAINTENANCES: {
    SEARCH: "/maintenances/search",
  },
  MAINTENANCES_ADMIN: {
    SEARCH: "/admin/maintenances/search",
  },
} as const;
